/** Les mots de partout : boutons, etats, erreurs generiques. */
export const commun = {
  annuler: 'Annuler',
  oui: 'Oui',
  actions: 'Actions',
  confirmer: 'Confirmer',
  retour: 'Retour',
  reessayer: 'Réessayer',
  pleinEcran: 'Photo en plein écran',
  fermer: 'Fermer',
  enLigne: 'En ligne',
  erreur: 'Une erreur est survenue',
  serveur: {
    refuse: 'Ce message ne respecte pas les règles de la communauté.',
    invalide: 'Message invalide',
    accesRefuse: 'Accès refusé.',
    indisponible: 'Publication impossible pour le moment. Réessaie dans un instant.',
  },
  choisisUnSpot: "Choisis d'abord un spot",
  membreInconnu: 'Membre inconnu',
  quelquun: 'Quelqu’un',
  nonConfigure: "Firebase n'est pas configuré. Renseigne client/.env.local (voir client/.env.example).",
  unInstant: 'Un instant…',
  envoi: 'Envoi…',
  uneLangue: 'Choisis au moins une langue.',
};
